module.exports = __webpack_public_path__ + "img/Hood.7e8752a5.png";